<template>
  <div class="address-card" :class="themedClass">
    <div class="address-card--mobile-wrapper">
      <svg class="address-card--map-pin" :width="svgSize" :height="svgSize" viewBox="0 0 28 28">
        <circle class="address-card--map-pin-circle-1" cx="14" cy="14" r="13"></circle>
        <circle class="address-card--map-pin-circle-2" cx="14" cy="14" r="11"></circle>
        <path
          class="address-card--map-pin-path"
          d="M18.3374 11.5521C18.3374 14.0662 14 21 14 21C14 21 9.66258 14.0662 9.66258 11.5521C9.66258 9.03805 11.6045 6.99999 14 6.99999C16.3955 6.99999 18.3374 9.03805 18.3374 11.5521Z"
        ></path>
        <circle
          class="address-card--map-pin-circle-3"
          cx="14.1054"
          cy="11.1987"
          r="1.35903"
        ></circle>
      </svg>
      <LsIcon
        v-if="showChevron && !screenSize.desktop"
        type="chevron"
        color="primary-light"
        size="md"
        class="address-card--chevron"
      />
    </div>
    <div class="address-container">
      <p class="street">{{ property.street }}</p>
      <p v-if="property.info.multitenant.is_multitenant">
        {{ property.info.multitenant.units.join(', ') }}
      </p>
      <p>{{ property.city }}, {{ property.state }}, {{ property.zip }}</p>
    </div>
    <LsIcon
      v-if="showChevron && screenSize.desktop"
      type="chevron"
      color="primary-light"
      size="md"
      class="address-card--chevron"
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import LsIcon from '@/components/common/LsIcon/LsIcon.vue';
import { mapState } from 'vuex';
import { lsPropTypeHelpers } from 'ls-vue-common';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LsAddressCard',
  components: {
    LsIcon,
  },
  mixins: [themedComponentMixin],
  props: {
    property: VueTypes.shape({
      street: VueTypes.string.isRequired,
      info: VueTypes.shape({
        multitenant: VueTypes.shape({
          is_multitenant: VueTypes.custom(lsPropTypeHelpers.booleanOrNull).isRequired,
          units: VueTypes.arrayOf(VueTypes.string).isRequired,
        }).isRequired.loose,
      }).isRequired.loose,
      city: VueTypes.string.isRequired,
      state: VueTypes.string.isRequired,
      zip: VueTypes.string.isRequired,
    }).isRequired.loose,
    showChevron: VueTypes.bool.def(false),
  },
  computed: {
    ...mapState(['screenSize']),
    svgSize() {
      const { is_multitenant } = this.property.info.multitenant;
      return is_multitenant ? 65 : 50;
    },
  },
};
</script>

<style lang="scss" scoped>
.address-card {
  color: $primary;
  display: inline-flex;
  align-items: center;
  .address-card--map-pin {
    & > .address-card--map-pin-circle-1 {
      fill: white;
      stroke: #d8f3e6;
      stroke-width: 2;
    }
    & > .address-card--map-pin-circle-2 {
      fill: #e5e5e5;
    }
    & > .address-card--map-pin-path {
      fill: #de4343;
    }
    & > .address-card--map-pin-circle-3 {
      fill: #ab3333;
    }
  }
  .address-container {
    padding-left: 20px;
  }
  .street {
    font-size: $size-4;
    font-weight: 700;
    max-width: 230px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.themed-component {
    color: $theme-color-primary;
    .address-card--map-pin {
      & > .address-card--map-pin-circle-1 {
        fill: $theme-color-white;
        stroke: $theme-color-primary-light;
      }
      & > .address-card--map-pin-circle-2 {
        fill: $theme-color-gray;
      }
      & > .address-card--map-pin-path {
        fill: $theme-color-danger;
      }
      & > .address-card--map-pin-circle-3 {
        fill: $theme-color-danger-dark;
      }
    }
  }
  @media (max-width: $mobile-max-width) {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    .address-container {
      padding-left: 0px;
    }
    .street {
      max-width: 200px;
    }
  }

  .address-card--mobile-wrapper {
    display: flex;
    align-items: center;
  }

  .address-card--chevron {
    margin-left: 30px;
    transform: rotate(90deg);
    @media (max-width: $mobile-max-width) {
      margin-left: 10px;
    }
  }
}
</style>
